import * as React from 'react'
import { Column, ColumnValue, AdobePreviewFileOptions, StatusOption } from '../types'
import { SelectCell } from './select_cell'
import { StatusCell } from './status_cell'
import { DateCell, isDateColumn } from './date_cell'
import { AttachmentCell, CommentAttachmentsCell, isAttachmentColumn, isCommentAttachmentColumn } from './attachment_cell'
import { isStatusColumn } from '../column_helpers'

const isTagColumn = (column: Column): boolean =>
  column.type === 'Projects::Columns::System' &&
  (column.key === 'elements' || column.key === 'element_groups' || column.key === 'element_placements')

export function renderCellValue(
  value: ColumnValue,
  column: Column,
  rowId: number,
  timeZone?: string,
  adobePreviewFileOptions?: AdobePreviewFileOptions
): React.ReactNode {
  if (value == null || value === '') {
    return null
  }

  if (isStatusColumn(column)) {
    // Status system columns use the status-flavoured option payload selected by the Rails serializer.
    return <StatusCell value={value} statusOptions={(column.column_options ?? []) as unknown as StatusOption[]} />
  }

  if (column.type === 'Projects::Columns::Select' || isTagColumn(column)) {
    return <SelectCell value={value} column={column} rowId={rowId} />
  }

  if (Array.isArray(value) && isCommentAttachmentColumn(column.key)) {
    return <CommentAttachmentsCell value={value} column={column} rowId={rowId} adobePreviewFileOptions={adobePreviewFileOptions} />
  }

  if (Array.isArray(value) && isAttachmentColumn(column.key)) {
    return <AttachmentCell value={value} column={column} rowId={rowId} adobePreviewFileOptions={adobePreviewFileOptions} />
  }

  if (isDateColumn(column.type, column.key)) {
    return <DateCell value={value} column={column} rowId={rowId} timeZone={timeZone} />
  }

  return String(value)
}
